exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-6e1e743e] {\n  padding: 15px 34px;\n  display: flex;\n  justify-content: space-between;\n}\n.header h2[data-v-6e1e743e] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.header .status[data-v-6e1e743e] {\n  font-size: 16px;\n}\n.disabled[data-v-6e1e743e] {\n  background-color: #f6f8f9;\n  color: #616f7b;\n  border: 1px solid #616f7b;\n}\n.date-time[data-v-6e1e743e] {\n  padding: 5px 0 5px 34px;\n}\n.date[data-v-6e1e743e] {\n  color: #000;\n}\n.flex[data-v-6e1e743e] {\n  align-items: center;\n}", ""]);

// exports
